import { FC } from "react";

import { Col, Row } from "antd";
import { clsx } from "clsx";

import { GenericCard } from "../../../../common/components/GenericCard";
import { Sanitized } from "../../../../common/components/Sanitized";
import { SvgIcon } from "../../../../common/components/SvgIcon";
import { POCReport } from "../../../../types/ReportTypes";
import classes from "./Outline.module.less";

export enum Chapter {
    ContractSummary = "contractSummary",
    NegotiationStrategy = "negotiationStrategy",
    TopLegalPriorities = "topLegalPriorities",
}

interface OutlineProps {
    open?: boolean;
    report?: POCReport;
    selectedChapter?: Chapter;
    onChapterChange?: (chapter: Chapter) => void;
    selectedSection?: string;
    onSectionChange?: (chapter: Chapter, section: string) => void;
    onClose?: () => void;
}
export const Outline: FC<OutlineProps> = ({
    open,
    report,
    selectedChapter,
    onChapterChange,
    selectedSection,
    onSectionChange,
    onClose,
}) => {
    const chapters = [
        {
            key: Chapter.ContractSummary,
            title: "Contract summary",
            sections: report?.contractSummaryV1,
        },
        {
            key: Chapter.NegotiationStrategy,
            title: "Negotiation strategy",
        },
        {
            key: Chapter.TopLegalPriorities,
            title: "Top contractual priorities",
        },
    ];

    const content = (
        <>
            <Row>
                <Col flex={1} className={classes.title}>
                    Outline
                </Col>
                <Col>
                    <SvgIcon
                        name="close"
                        size={12}
                        color="#1890FF"
                        className={classes.icon}
                        onClick={onClose}
                    />
                </Col>
            </Row>
            {chapters?.map((c) => (
                <div key={c.key}>
                    <div
                        className={clsx(
                            classes.chapter,
                            c.key === selectedChapter && classes.chapterActive
                        )}
                        onClick={() => onChapterChange?.(c.key)}
                    >
                        {c.title}
                    </div>
                    {c.sections && c.sections.length > 1 ? (
                        <div>
                            {c.sections.map((s, index) => (
                                <div
                                    className={clsx(
                                        classes.section,
                                        c.key === selectedChapter &&
                                            index.toString() === selectedSection &&
                                            classes.sectionActive
                                    )}
                                    key={index}
                                    onClick={() => onSectionChange?.(c.key, index.toString())}
                                >
                                    <Sanitized
                                        className={classes.sectionTitle}
                                        content={s.key.trim().replace(/^\d+\. */, "")}
                                    />
                                </div>
                            ))}
                        </div>
                    ) : null}
                </div>
            ))}
        </>
    );
    return (
        <GenericCard className={clsx(classes.container, !open && classes.collapsed)} size="large">
            <div className={classes.content}>{content}</div>
        </GenericCard>
    );
};
